export const userCardKeys = {
	all: ["user-cards"] as const,
	lists: () => [...userCardKeys.all, "list"] as const,
	list: (userId: number) => [...userCardKeys.lists(), userId] as const,
} as const
